module.exports = __webpack_public_path__ + "img/extracadabra_app.67565705.png";